<h2 mat-dialog-title class="flex items-center gap-2">
  <mat-icon class="text-status-error">warning</mat-icon>
  {{ 'ORG_DELETE_DIALOG.TITLE' | translate }}
</h2>

<mat-dialog-content>
  <p class="mb-3">
    {{ 'ORG_DELETE_DIALOG.INTRO' | translate : { name: data.displayName } }}
  </p>
  <ul class="list-disc pl-5 text-sm text-secondary mb-3">
    <li>{{ 'ORG_DELETE_DIALOG.ITEM_ORG' | translate }}</li>
    <li>{{ 'ORG_DELETE_DIALOG.ITEM_USERS' | translate : { count: data.userCount } }}</li>
    <li>{{ 'ORG_DELETE_DIALOG.ITEM_AUDITS' | translate }}</li>
  </ul>
  <p class="text-sm font-medium text-status-error">
    {{ 'ORG_DELETE_DIALOG.WARNING' | translate }}
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="cancel()">
    {{ 'COMMON.CANCEL' | translate }}
  </button>
  <button mat-flat-button color="warn" (click)="confirm()" class="ml-2">
    <mat-icon>delete_forever</mat-icon>
    {{ 'ORG_DELETE_DIALOG.CONFIRM_BTN' | translate }}
  </button>
</mat-dialog-actions>
